module.exports = __webpack_public_path__ + "img/cooperate-base.902b6b92.png";